module.exports = __webpack_public_path__ + "static/media/next.84b92501.svg";